export default {
  // 复制 拷贝字符串到剪贴板
  copy(url) {
    const oInput = document.createElement('input')
    oInput.value = url
    document.body.appendChild(oInput)
    oInput.select()
    document.execCommand('Copy')
    oInput.className = 'oInput'
    oInput.style.display = 'none'
  },

  // 滚动到顶部
  scroll_to_top(selecter) {
    const el = selecter
      ? document.querySelector(selecter)
      : document.documentElement
    let step = 0
    let timer = setInterval(() => {
      if (el.scrollTop <= 0) {
        clearInterval(timer)
        return
      }
      step += 10
      el.scrollTop -= step
    }, 20)
  },

  // 指定元素滚动到最低部，该元素必须设置overflow-y: auto|scroll|hidden;
  scroll_to_ele_btm(selecter) {
    const el = selecter
      ? document.querySelector(selecter)
      : document.documentElement
    let step = 0
    let timer = setInterval(() => {
      if (el.scrollTop >= el.scrollHeight - el.offsetHeight) {
        clearInterval(timer)
        return
      }
      step += 10
      el.scrollTop += step
    }, 20)
  },

  // ASCII码排序
  sort_by_ASCII: (arr, key) => {
    arr.sort().join('') + key
  },

  // 字符串末尾数字部分增加1
  plus_string_end_number: str => {
    return str.replace(/\d+$/, function(numStr) {
      let x = '',
        i = (l = numStr.length)
      while (i) {
        x += '0'
        i--
      }
      return (x + (parseInt(numStr, 10) + 1)).slice(l * -1)
    })
  },

  full_screen_toggle: () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.msCancelFullScreen) {
        document.msCancelFullScreen()
      }
    } else {
      let body = document.querySelector('body')
      if (body.requestFullScreen) {
        body.requestFullScreen()
      } else if (body.webkitRequestFullScreen) {
        body.webkitRequestFullScreen()
      } else if (body.mozRequestFullScreen) {
        body.mozRequestFullScreen()
      } else if (body.msRequestFullScreen) {
        body.msRequestFullScreen()
      }
    }
  },

  html_to_text: val => {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
  },
}
